<template>
	<el-drawer size="800px" title="优先级设置" :visible.sync="drawer" :modal-append-to-body="false" :wrapperClosable="false" class="customer-drawer-common">
		<section class="user-box" v-loading="loading">
			<div v-if="lists.length > 0">
				<div class="header">
					<span class="item">用户</span>
					<span class="item">Level
					<el-tooltip class="item" effect="dark" content="Level值用来判断多个坐席在同时空闲时的接线的优先级。Level级别越高（1最大），优先接线" placement="top">
						<i class="el-icon-info"></i>
					</el-tooltip>
				</span>
					<!-- <span class="item">Position</span> -->
					<span class="item">操作</span>
				</div>
				<div class="cell" v-for="(item, index) in lists" :key="index">
					<span class="item">{{item.nickname}}</span>
					<span class="item">
						<el-input-number v-model="item.level" :min="1" :max="100" size="mini"></el-input-number>
					</span>
					<!-- <span class="item">
						<el-input-number v-model="item.position" :min="1" :max="10" size="mini"></el-input-number>
					</span> -->
					<span class="item">
						<el-button @click.stop="handleSave(item)" :loading="loadingSubmit" size="mini" type="primary">保存</el-button>
					</span>
				</div>
			</div>
			<el-empty v-else description="暂无数据"></el-empty>
		</section>
	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				drawer: false,
				loading:false,
				lists: [],
				brand: '',
				skillGroup: '',
				loadingSubmit: false
			}
		},
		methods: {
			handleSave(item) {
				this.loadingSubmit = true;
				this.$api.apiPostUpdateAgentLevel(item).then(response => {
					if(response.errcode != 0) {
						this.loadingSubmit = false;
						return;
					};
					this.loadingSubmit = false;
				}).catch(() => {
					this.loadingSubmit = false;
				});
			},
			async getAllUser(){
				this.loading = true;
				this.lists = [];
				await this.$api.apiPostLarkswitchManageQueueAgentList({queueName:this.skillGroup}).then(res => {
					if(res.errcode != 0) {
						this.loading = false;
						return;
					};
					for(const item of res.data) {
						if(item.account) {
							this.$set(item, 'level', item?.level || 1);
							this.$set(item, 'position',  item?.position || 1);
							this.$set(item, 'projectCode', this.brand);
							this.$set(item, 'queueName', this.skillGroup);
							this.lists.push(item);
						}
					}
					this.loading = false;
				}).catch(() => {
					this.loading = false;
				});
			},
			async onOpen(row){
				this.drawer = true;
				this.loading = true;
				this.skillGroup = row.queueName;
				this.brand = row.projectCode;
				await this.getAllUser();
			}
		}
	}
</script>
<style lang="scss" scoped>
.user-box {
	width: 100%;
	border: solid 1px #e1e1e1;
	margin-bottom: 10px;

	& .header {
		width: 100%;
		height: 40px;
		background: #fafafa;
		& > .item {
			display: inline-block;
			vertical-align: top;
			width: calc((100% - 380px));
			height: 40px;
			border-right: solid 1px #e1e1e1;
			box-sizing: border-box;
			text-align: center;
			font-size: 14px;
			color: #333;
			font-weight: bold;
			line-height: 40px;

			&:nth-of-type(1) {
				width: 300px;
			}

			&:nth-of-type(3) {
				width: 80px;
				border-right: node;
			}
		}
	}

	& .cell {
		width: 100%;
		height: 40px;
		border-top: solid 1px #e1e1e1;

		& > .item {
			display: inline-block;
			vertical-align: top;
			width: calc((100% - 380px));
			height: 40px;
			border-bottom: solid 1px #e1e1e1;
			border-right: solid 1px #e1e1e1;
			padding: 6px 0;
			box-sizing: border-box;
			text-align: center;

			&:nth-of-type(1) {
				width: 300px;
				font-size: 14px;
				color: #333;
				line-height: 28px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				padding: 6px 8px;
				box-sizing: border-box;
			}

			&:nth-of-type(3) {
				width: 80px;
				border-right: node;
				text-align: center;
			}
		}
	}
}
</style>
